import { render } from "./CompanyTechnologyDetial.vue?vue&type=template&id=1d047956&scoped=true"
import script from "./CompanyTechnologyDetial.vue?vue&type=script&lang=js"
export * from "./CompanyTechnologyDetial.vue?vue&type=script&lang=js"

import "./CompanyTechnologyDetial.vue?vue&type=style&index=0&id=1d047956&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d047956"]])

export default __exports__